import { QueryClient } from '@tanstack/react-query';

import { clearRecents } from './shell/recents';

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
      mutations: { retry: 0 },
    },
  });
}

/** Logout (LGPD): aborta o que está em voo, esvazia queries e mutações da sessão que saiu e os recentes da Início. */
export function clearSessionCache(client: QueryClient) {
  void client.cancelQueries();
  client.clear();
  clearRecents();
}
